import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function RemoveModeratorIcon(props: IconProps) {
    return <Icon {...props} iconKey={"remove_moderator"}/>
}
